import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process, State } from '@progress/kendo-data-query';
import { Employee } from 'src/app/models/employee.model';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { images } from 'src/app/resources/images';
import { Site } from 'src/app/models/site.model';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { SiteFormComponent } from '../sites-form/sites-form.component';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { NotificationService } from '@progress/kendo-angular-notification';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";


@Component({
    selector: 'app-sites-component',
    templateUrl: './sites-component.html'
})
export class SitesComponent implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public gridData: Site[] = [];
    public gridView: any[] = [];
    public filter: CompositeFilterDescriptor | undefined;
    public mySelection: string[] = [];
    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService,
        private dialogService: DialogService, private api: ApiService, private notificationService: NotificationService,) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.allData = this.allData.bind(this);
    }

    public load() {
        this.api
            .getRequest<BaseHttpResponse<Site[]>>("Local/GetLocais")
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });

    }

    public ngOnInit(): void {
        this.gridView = this.gridData;
        this.load();

    }

    // Update Grid collection during changing My Team/All Team
    public onTeamChange(pageSize: number): void {
        pageSize === 25
            ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
            : (this.gridView = this.gridData.slice(0, pageSize));
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;
        this.dataBinding ? this.dataBinding.skip = 0 : null;
    }

    public getField = (args: Employee) => {
        return `${args.nome}_${args.idFuncao}_${args.codigoDeFuncionario}_${args.telemovel}_${args.email}`;
    }

    public photoURL(dataItem: any): string {
        const code: string = dataItem.imgId;
        const image: any = images;
        return image[code];
    }

    public flagURL(dataItem: any): string {
        const code: string = dataItem.country;
        const image: any = images;
        return image[code];
    }

    canList() {
        return User.canLocaisList();
    }

    canCreate() {
        return User.canLocaisCreate();
    }

    canDelete() {
        return User.canLocaisDelete();
    }

    canEdit() {
        return User.canLocaisEdit();
    }

    public open(): void {
        const dialogRef: DialogRef = this.dialogService.open({
            title: this.customMsgService.translate('btnCriar') + " " + this.customMsgService.translate('local'),
            content: SiteFormComponent,
        });
        const userInfo = dialogRef.content.instance as SiteFormComponent;
        dialogRef.result.subscribe((result) => {
            this.load();
        });
    }

    public delete(e: Site): void {
        var sim = this.customMsgService.translate('yes');
        var nao = this.customMsgService.translate('no');
        const dialog: DialogRef = this.dialogService.open({
            appendTo: this.container,
            title: this.customMsgService.translate('confirmacao'),
            content: this.customMsgService.translate('desejaRemover'),
            actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
            width: 450,
            height: 200,
            minWidth: 250,
        });
        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
            } else if (result.text == sim) {
                this.api.cruddelete<BaseHttpResult>('Local', e.id).
                    then(res => {
                        if (res.ok) {
                            this.notificationService.show({
                                appendTo: this.container,
                                content: this.customMsgService.translate('registoApagadoComSucesso'),
                                animation: { type: 'slide', duration: 500 },
                                position: { horizontal: 'center', vertical: 'top' },
                                type: { style: 'success', icon: true },
                                hideAfter: 2000
                            });
                            this.load();
                        } else {

                            this.notificationService.show({
                                appendTo: this.container,
                                content: res.message,
                                animation: { type: 'slide', duration: 500 },
                                position: { horizontal: 'center', vertical: 'top' },
                                type: { style: 'error', icon: true },
                                hideAfter: 4000
                            });
                        }

                    }).
                    catch(err => {
                    });
            }
        });
    }

    public openEdit(c: Site): void {
        const dialogRef: DialogRef = this.dialogService.open({
            title: this.customMsgService.translate('btnEditar') + " " + this.customMsgService.translate('local'),
            content: SiteFormComponent,
        });
        const userInfo = dialogRef.content.instance as SiteFormComponent;
        userInfo.formValue = c;
        userInfo.setFormValues();
        dialogRef.result.subscribe((result) => {
            this.load();
        });
    }

    public allData(): ExcelExportData {
        const result: ExcelExportData = {
            data: process(this.gridView, { filter: this.filter }).data,
        };
        return result;
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.gridView, filter);
    }
}
